import { FC, useState, useMemo } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
import { Grid, TextField, Button, Paper } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';
import { useHistory } from 'react-router';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { blue } from '@material-ui/core/colors';
import { getTenantFromSubdomain, isValidTenant } from 'utils/tenantUtils';
const Authenticate: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const {
    userStore: { AuthenticatorVerify },
    notificationStore: { openNotification },
  } = useStore();
  const tokens = localStorage.getItem('token');
  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const [isValidDomain, setIsValidDomain] = useState<boolean>(true);

  const domain = useMemo(() => {
    const tenant = getTenantFromSubdomain();

    if (tenant === null) {
      setIsValidDomain(false);
      return '';
    }

    if (!isValidTenant(tenant)) {
      setIsValidDomain(false);
      return '';
    }

    setIsValidDomain(true);
    return tenant;
  }, []);
  const VertifyRequest = useMutation(
    () => {
      if (!code || isNaN(Number(code))) {
        throw new Error('Code is required and must be a number');
      }
      return AuthenticatorVerify({ code });
    },
    {
      mutationKey: 'VertifyRequest',
      onSuccess: () => {
        if (profile?.permission !== 'EndUser' && profile?.permission !== 'Manager') {
          if (!isValidDomain) {
            const hostName = domain || localStorage.getItem('domain');
            const protocol = window.location.protocol;
            const hostname = window.location.hostname;
            const port = window.location.port;
            const token = localStorage.getItem('token')?.replace('Bearer ', '');
            const orgName = localStorage.getItem('organizationName');
            if (hostName && !hostname.startsWith(`${hostName}.`)) {
              const isLocalhost = hostname.includes('localhost');
              let baseHost;
              if (isLocalhost) {
                baseHost = `localhost${port ? ':' + port : ''}`;
              } else {
                const parts = hostname.split('.');
                baseHost = parts.length === 2 ? hostname : parts.slice(1).join('.');
              }
              // Clean hostName to remove any protocol if present
              const cleanHostName = hostName.replace(/^https?:\/\//, '');
              const redirectUrl = `${protocol}//${cleanHostName}.${baseHost}/dashboard?token=${token}&userData=${encodeURIComponent(
                JSON.stringify(profile)
              )}&orgName=${encodeURIComponent(orgName || '')}`;
              window.location.href = redirectUrl;
            }
          } else {
            history.push('/dashboard');
          }
        } else if (tokens && (profile?.permission === 'EndUser' || profile?.permission === 'Manager')) {
          if (!isValidDomain) {
            const hostName = domain || localStorage.getItem('domain');
            const protocol = window.location.protocol;
            const hostname = window.location.hostname;
            const port = window.location.port;
            const token = localStorage.getItem('token')?.replace('Bearer ', '');
            const orgName = localStorage.getItem('organizationName');
            if (hostName && !hostname.startsWith(`${hostName}.`)) {
              const isLocalhost = hostname.includes('localhost');
              let baseHost;
              if (isLocalhost) {
                baseHost = `localhost${port ? ':' + port : ''}`;
              } else {
                const parts = hostname.split('.');
                baseHost = parts.length === 2 ? hostname : parts.slice(1).join('.');
              }
              // Clean hostName to remove any protocol if present
              const cleanHostName = hostName.replace(/^https?:\/\//, '');
              const redirectUrl = `${protocol}//${cleanHostName}.${baseHost}/users?token=${token}&userData=${encodeURIComponent(
                JSON.stringify(profile)
              )}&orgName=${encodeURIComponent(orgName || '')}`;
              window.location.href = redirectUrl;
            }
          } else {
            history.push('/users');
          }
        } else {
          history.push(handleCompanyUrl('/reports'));
        }
      },
      onError: ({ message }: Error) => {
        openNotification('error', message ? message : 'Something went wrong');
      },
    }
  );
  const [code, setCode] = useState<string>('');
  const handleCode = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setCode(value);
    }
  };
  useAppPreloader(VertifyRequest.isLoading);
  return (
    <Grid item className={classes.container}>
      <div className={classes.topBars}>
        <LogoIcon style={{ marginLeft: '40px', width: '140px', height: '52px' }} />
      </div>
      <Grid container className={classes.main} justify='center'>
        <Grid item lg={4}>
          <Paper className={classes.paper} elevation={3}>
            <h1 className={classes.title}>Two-Factor Authentication Code</h1>
            <Grid container justify='center' style={{ marginTop: '20px' }}>
              <p>Please fill in the code that you see in the Authenticator App</p>
            </Grid>
            <Grid container justify='center'>
              <TextField
                className={classes.formControl}
                id='code'
                value={code}
                onChange={handleCode}
                required
                fullWidth
                placeholder='Enter Code'
                variant='outlined'
                label=''
                autoFocus
              />
            </Grid>
            <Grid className={classes.formControl} container justify='space-between'>
              <Button
                className={classes.button}
                variant='contained'
                color='primary'
                onClick={() => {
                  VertifyRequest.mutate();
                }}
              >
                LOG IN
              </Button>
            </Grid>
          </Paper>
        </Grid>
        <Grid container className={classes.main} justify='center'>
          <Grid item lg={4}>
            <Paper className={classes.paperHelp} elevation={3}>
              <h1>Having Problems?</h1>
              <span
                style={{ padding: '10px 0px', color: blue[800], cursor: 'pointer' }}
                onClick={() => {
                  history.push(handleCompanyUrl('/two-factor/recovery'));
                }}
              >
                • Use a recovery code or begin 2FA account recovery.
              </span>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});

export default Authenticate;
